import mod from "-!./collaboration.js?vue&type=script&lang=js&"; export default mod; export * from "-!./collaboration.js?vue&type=script&lang=js&"